import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import cvrValidator from 'foundation/js/inputValidators/cvrValidator'

const options = formFieldCommonOptions('FormInputCvrField', {
    validatorFunction(input) {
        return cvrValidator(input)
    }
})

export default options
